import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import StafetDonationStepPrivat from '../StafetDonationStepPrivat/StafetDonationStepPrivat.vue'
import StafetDonationStepVirksomhed from '../StafetDonationStepVirksomhed/StafetDonationStepVirksomhed.vue'
import { useStore } from 'vuex'
import { computed, onBeforeMount, ref } from 'vue'

export default {
    name: 'StafetDonationStepTwo',
    components: {
        StafetDonationStepPrivat,
        StafetDonationStepVirksomhed
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const componentName = ref('')

        const userInputs = computed(() => {
            return store.state.donation.userInputs
        })

        onBeforeMount(() => {
            const donationType = userInputs.value.find(
                (item) => item.name === 'type'
            )

            if (donationType) {
                switch (donationType.value) {
                    case 'Privat':
                        componentName.value = 'StafetDonationStepPrivat'
                        break
                    case 'Virksomhed':
                        componentName.value = 'StafetDonationStepVirksomhed'
                        break
                    default:
                        if (props.previousStepCallback) {
                            props.previousStepCallback()
                        }
                }
            }
        })

        return {
            componentName
        }
    }
}
